/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.LoginMsg = (function() {

    /**
     * Properties of a LoginMsg.
     * @exports ILoginMsg
     * @interface ILoginMsg
     * @property {string|null} [guid] LoginMsg guid
     * @property {number|null} [version] LoginMsg version
     * @property {string|null} [fromGuid] LoginMsg fromGuid
     * @property {LoginMsg.Role|null} [role] LoginMsg role
     * @property {string|null} [token] LoginMsg token
     */

    /**
     * Constructs a new LoginMsg.
     * @exports LoginMsg
     * @classdesc Represents a LoginMsg.
     * @implements ILoginMsg
     * @constructor
     * @param {ILoginMsg=} [properties] Properties to set
     */
    function LoginMsg(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * LoginMsg guid.
     * @member {string} guid
     * @memberof LoginMsg
     * @instance
     */
    LoginMsg.prototype.guid = "";

    /**
     * LoginMsg version.
     * @member {number} version
     * @memberof LoginMsg
     * @instance
     */
    LoginMsg.prototype.version = 0;

    /**
     * LoginMsg fromGuid.
     * @member {string} fromGuid
     * @memberof LoginMsg
     * @instance
     */
    LoginMsg.prototype.fromGuid = "";

    /**
     * LoginMsg role.
     * @member {LoginMsg.Role} role
     * @memberof LoginMsg
     * @instance
     */
    LoginMsg.prototype.role = 0;

    /**
     * LoginMsg token.
     * @member {string} token
     * @memberof LoginMsg
     * @instance
     */
    LoginMsg.prototype.token = "";

    /**
     * Creates a new LoginMsg instance using the specified properties.
     * @function create
     * @memberof LoginMsg
     * @static
     * @param {ILoginMsg=} [properties] Properties to set
     * @returns {LoginMsg} LoginMsg instance
     */
    LoginMsg.create = function create(properties) {
        return new LoginMsg(properties);
    };

    /**
     * Encodes the specified LoginMsg message. Does not implicitly {@link LoginMsg.verify|verify} messages.
     * @function encode
     * @memberof LoginMsg
     * @static
     * @param {ILoginMsg} message LoginMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LoginMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.guid != null && Object.hasOwnProperty.call(message, "guid"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.guid);
        if (message.version != null && Object.hasOwnProperty.call(message, "version"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.version);
        if (message.fromGuid != null && Object.hasOwnProperty.call(message, "fromGuid"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.fromGuid);
        if (message.role != null && Object.hasOwnProperty.call(message, "role"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.role);
        if (message.token != null && Object.hasOwnProperty.call(message, "token"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.token);
        return writer;
    };

    /**
     * Encodes the specified LoginMsg message, length delimited. Does not implicitly {@link LoginMsg.verify|verify} messages.
     * @function encodeDelimited
     * @memberof LoginMsg
     * @static
     * @param {ILoginMsg} message LoginMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LoginMsg.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a LoginMsg message from the specified reader or buffer.
     * @function decode
     * @memberof LoginMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {LoginMsg} LoginMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LoginMsg.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.LoginMsg();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.guid = reader.string();
                    break;
                }
            case 2: {
                    message.version = reader.int32();
                    break;
                }
            case 3: {
                    message.fromGuid = reader.string();
                    break;
                }
            case 4: {
                    message.role = reader.int32();
                    break;
                }
            case 5: {
                    message.token = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a LoginMsg message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof LoginMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {LoginMsg} LoginMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LoginMsg.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a LoginMsg message.
     * @function verify
     * @memberof LoginMsg
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    LoginMsg.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.guid != null && message.hasOwnProperty("guid"))
            if (!$util.isString(message.guid))
                return "guid: string expected";
        if (message.version != null && message.hasOwnProperty("version"))
            if (!$util.isInteger(message.version))
                return "version: integer expected";
        if (message.fromGuid != null && message.hasOwnProperty("fromGuid"))
            if (!$util.isString(message.fromGuid))
                return "fromGuid: string expected";
        if (message.role != null && message.hasOwnProperty("role"))
            switch (message.role) {
            default:
                return "role: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
                break;
            }
        if (message.token != null && message.hasOwnProperty("token"))
            if (!$util.isString(message.token))
                return "token: string expected";
        return null;
    };

    /**
     * Creates a LoginMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof LoginMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {LoginMsg} LoginMsg
     */
    LoginMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.LoginMsg)
            return object;
        var message = new $root.LoginMsg();
        if (object.guid != null)
            message.guid = String(object.guid);
        if (object.version != null)
            message.version = object.version | 0;
        if (object.fromGuid != null)
            message.fromGuid = String(object.fromGuid);
        switch (object.role) {
        default:
            if (typeof object.role === "number") {
                message.role = object.role;
                break;
            }
            break;
        case "UNKNOWN":
        case 0:
            message.role = 0;
            break;
        case "AGENT":
        case 1:
            message.role = 1;
            break;
        case "CUSTOMER":
        case 2:
            message.role = 2;
            break;
        case "CUSTOMER_MINI":
        case 3:
            message.role = 3;
            break;
        case "CUSTOMER_CLIENT":
        case 4:
            message.role = 4;
            break;
        case "CUSTOMER_HAOFANG_MINI":
        case 5:
            message.role = 5;
            break;
        case "TIANTIAN_CUSTOMER_CLIENT":
        case 6:
            message.role = 6;
            break;
        case "CUSTOMER_MINI_TIANTIAN":
        case 7:
            message.role = 7;
            break;
        case "TIANCHENG_CUSTOMER_CLIENT":
        case 8:
            message.role = 8;
            break;
        case "CUSTOMER_MINI_TIANCHENG":
        case 9:
            message.role = 9;
            break;
        case "CUSTOMER_MINI_DOUYIN":
        case 10:
            message.role = 10;
            break;
        case "WEB_CLIENT":
        case 11:
            message.role = 11;
            break;
        }
        if (object.token != null)
            message.token = String(object.token);
        return message;
    };

    /**
     * Creates a plain object from a LoginMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof LoginMsg
     * @static
     * @param {LoginMsg} message LoginMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    LoginMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.guid = "";
            object.version = 0;
            object.fromGuid = "";
            object.role = options.enums === String ? "UNKNOWN" : 0;
            object.token = "";
        }
        if (message.guid != null && message.hasOwnProperty("guid"))
            object.guid = message.guid;
        if (message.version != null && message.hasOwnProperty("version"))
            object.version = message.version;
        if (message.fromGuid != null && message.hasOwnProperty("fromGuid"))
            object.fromGuid = message.fromGuid;
        if (message.role != null && message.hasOwnProperty("role"))
            object.role = options.enums === String ? $root.LoginMsg.Role[message.role] === undefined ? message.role : $root.LoginMsg.Role[message.role] : message.role;
        if (message.token != null && message.hasOwnProperty("token"))
            object.token = message.token;
        return object;
    };

    /**
     * Converts this LoginMsg to JSON.
     * @function toJSON
     * @memberof LoginMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    LoginMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for LoginMsg
     * @function getTypeUrl
     * @memberof LoginMsg
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    LoginMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/LoginMsg";
    };

    /**
     * Role enum.
     * @name LoginMsg.Role
     * @enum {number}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} AGENT=1 AGENT value
     * @property {number} CUSTOMER=2 CUSTOMER value
     * @property {number} CUSTOMER_MINI=3 CUSTOMER_MINI value
     * @property {number} CUSTOMER_CLIENT=4 CUSTOMER_CLIENT value
     * @property {number} CUSTOMER_HAOFANG_MINI=5 CUSTOMER_HAOFANG_MINI value
     * @property {number} TIANTIAN_CUSTOMER_CLIENT=6 TIANTIAN_CUSTOMER_CLIENT value
     * @property {number} CUSTOMER_MINI_TIANTIAN=7 CUSTOMER_MINI_TIANTIAN value
     * @property {number} TIANCHENG_CUSTOMER_CLIENT=8 TIANCHENG_CUSTOMER_CLIENT value
     * @property {number} CUSTOMER_MINI_TIANCHENG=9 CUSTOMER_MINI_TIANCHENG value
     * @property {number} CUSTOMER_MINI_DOUYIN=10 CUSTOMER_MINI_DOUYIN value
     * @property {number} WEB_CLIENT=11 WEB_CLIENT value
     */
    LoginMsg.Role = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "AGENT"] = 1;
        values[valuesById[2] = "CUSTOMER"] = 2;
        values[valuesById[3] = "CUSTOMER_MINI"] = 3;
        values[valuesById[4] = "CUSTOMER_CLIENT"] = 4;
        values[valuesById[5] = "CUSTOMER_HAOFANG_MINI"] = 5;
        values[valuesById[6] = "TIANTIAN_CUSTOMER_CLIENT"] = 6;
        values[valuesById[7] = "CUSTOMER_MINI_TIANTIAN"] = 7;
        values[valuesById[8] = "TIANCHENG_CUSTOMER_CLIENT"] = 8;
        values[valuesById[9] = "CUSTOMER_MINI_TIANCHENG"] = 9;
        values[valuesById[10] = "CUSTOMER_MINI_DOUYIN"] = 10;
        values[valuesById[11] = "WEB_CLIENT"] = 11;
        return values;
    })();

    return LoginMsg;
})();

module.exports = $root;
